import React, {Component, Fragment} from 'react';
import {Content, FormBack, ResultsCounterTermed, Sanitize} from 'cw-styleguide-react';
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {withTranslation} from "react-i18next";
import {route} from "../../../routes";
import config from "../../../config";
import i18n from "../../../i18n";
import {GelContentContainer, GelContentRow, GelContentColumn, ListingSidebar} from 'cw-styleguide-react';
import AutocompleteSearch from "../../../components/AutocompleteSearch";
import Tabs from "../../../components/Tabs";
import Helmet from 'react-helmet';

class SubjectsDetailView extends Component {


  render() {

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.data.name} | {this.props.t('route_subjects_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('subjects') + route('subject', {subject: this.props.slug})}>
          {this.props.data.name}
        </BreadcrumbsItem>
        <AutocompleteSearch  jobs={this.props.jobs}/>
        <GelContentContainer>
          <Tabs/>
          <FormBack url={route('subjects')} title={this.props.title} theme={['secondary']}/>
          <h2>{this.props.data.name}</h2>
          <Sanitize html={this.props.data.description}  classes={['style--list-circle','style--list-no-bg']}/>
          <ResultsCounterTermed count={this.props.data.jobs.length} item={this.props.t('job_titles')}
                                category={this.props.data.name}/>
          <GelContentRow>
            <GelContentColumn xs={12} sm={12} md={8} lg={8}>
              <ul className="style--columns-2 style--list-plain style--list-large">
                {this.props.data.jobs.map((job, index) => {
                  return (
                    <li key={index}>
                      <a className={'anchor-list__link gel-md-mb-20'}
                         href={config.basePath[i18n.language] + '/' + job.slug}>{job.name}</a>
                    </li>
                  );
                })}
              </ul>
            </GelContentColumn>
            <GelContentColumn xs={12} sm={12} md={4} lg={4}>
              <ListingSidebar subheading={this.props.t('subjects_sidebar_subheading')}
                              items={this.props.data.articles.map(article => {
                                return {
                                  to: config.basePath[i18n.language] + '/' + this.props.t('route_articles') + '/' + article.slug,
                                  text: article.name
                                };
                              })} moreLink={{to: '/' + this.props.t('route_articles'), text: this.props.t('view_all_articles')}}>
                <p>{this.props.t('subjects_sidebar_text')}</p>
              </ListingSidebar>
            </GelContentColumn>
          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(SubjectsDetailView);
